import CertificatePoa from '@views/poa/CertificatePoa.vue'

export default [
  {
    path: '/user/poa/:token',
    name: 'CertificatePoa',
    component: CertificatePoa,
    props: (route) => ({
      token: route.params.token
    }),
    meta: {
      title: '修了証の確認',
      gaTitle: '修了証の確認',
      header: true,
      nav: 'none',
      footer: true
    }
  }
]
